// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Models
import { useFormDataType } from '@lyon/scoped-models/form/FormData';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
// import { Divider } from '@lyon/components/utils/Divider';
import { LyonUpdateEssayCaption } from './LyonUpdateEssayCaption';
// import { LyonUpdateEssayCorrectFeedback } from './LyonUpdateEssayCorrectFeedback';
// import { LyonUpdateEssayIncorrectFeedback } from './LyonUpdateEssayIncorrectFeedback';
// import { LyonUpdateEssayIndeterminateFeedback } from './LyonUpdateEssayIndeterminateFeedback';
import { LyonUpdateEssayName } from './LyonUpdateEssayName';
import { LyonUpdateEssayPointsPossible } from './LyonUpdateEssayPointsPossible';

export const LyonUpdateFormContentEssay = constant(() => {
  const formType = useFormDataType();

  return (
    <Block width="65%">
      <LyonUpdateEssayName />
      <LyonUpdateEssayCaption />
      {
        formType === 'quiz' && (
          <>
            <LyonUpdateEssayPointsPossible />
            {/* <Divider />
            <LyonUpdateEssayCorrectFeedback />
            <LyonUpdateEssayIncorrectFeedback />
            <LyonUpdateEssayIndeterminateFeedback /> */}
          </>
        )
      }
    </Block>
  );
});
